// Centralised data-testid constants for CFL Ad Group site
export const NAV = {
    logo: 'nav-logo-link',
    home: 'nav-home-link',
    about: 'nav-about-link',
    services: 'nav-services-link',
    industries: 'nav-industries-link',
    work: 'nav-work-link',
    articles: 'nav-articles-link',
    contact: 'nav-contact-link',
    cta: 'nav-cta-button',
    mobileToggle: 'nav-mobile-toggle',
    mobileMenu: 'nav-mobile-menu',
};

export const HERO = {
    section: 'hero-section',
    title: 'hero-title',
    subtitle: 'hero-subtitle',
    primaryCta: 'hero-primary-cta',
    secondaryCta: 'hero-secondary-cta',
};

export const HOME = {
    pillars: 'home-pillars',
    pillarBuildBrand: 'home-pillar-building-brand',
    pillarMedia: 'home-pillar-media',
    pillarSocial: 'home-pillar-social',
    whatWeDo: 'home-what-we-do',
    aboutSnapshot: 'home-about-snapshot',
    industries: 'home-industries',
    workReel: 'home-work-reel',
    testimonial: 'home-testimonial',
    articles: 'home-articles',
    cta: 'home-cta-banner',
    emergentLink: 'home-emergent-link',
};

export const CONTACT = {
    section: 'contact-section',
    form: 'contact-form',
    inputName: 'contact-input-name',
    inputEmail: 'contact-input-email',
    inputPhone: 'contact-input-phone',
    inputCompany: 'contact-input-company',
    inputSubject: 'contact-input-subject',
    inputMessage: 'contact-input-message',
    submit: 'contact-submit-button',
    success: 'contact-success-message',
    error: 'contact-error-message',
};

export const FOOTER = {
    root: 'site-footer',
    subscribeForm: 'footer-subscribe-form',
    subscribeInput: 'footer-subscribe-input',
    subscribeButton: 'footer-subscribe-button',
    subscribeSuccess: 'footer-subscribe-success',
    contactCtaLink: 'footer-contact-cta',
    socialFacebook: 'footer-social-facebook',
    socialTwitter: 'footer-social-twitter',
    socialYoutube: 'footer-social-youtube',
};
